export const Banner = () => {
  return (
    <section id='Section Atlas Y Cronos'>
      <div className='banner'>
        <div className='banner__content'>
          <div className='txt'>
            <div className='txt__content'>
              <div className='logo-lippi-vulcano'>
                <img
                  src='https://res.cloudinary.com/lippi-outdoor/image/upload/v1682431180/logo_vulcano_lippi_Mesa_de_trabajo_1_copia_1_kbm2wi.png'
                  alt='Lippi Vulcano'
                ></img>
              </div>
              <div className='logo-atlas-cronos'>
                <img
                  src='https://res.cloudinary.com/lippi-outdoor/image/upload/v1682431178/ATLAS_Y_KRONOS_1_jj5otp.png'
                  alt='Atlas y Cronos'
                ></img>
              </div>
              <div className='btn-white'>
                <a
                  href='https://www.lippioutdoor.com/atlas-y-kronos.html'
                  target='_parent'
                  id='btn-banner'
                >
                  Productos
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
